import DashboardState, { actions } from '@/pages/Dashboard/Dashboard.redux.js';
import { ProfileOutlined, DollarOutlined } from '@ant-design/icons';
import React, { lazy } from 'react';

import { registerNavigation } from '@/core/navigation';
import { registerReduxStore } from '@/core/store';
import { registerRoutes } from '@/core/routes';

const Dashboard = lazy(() => import('./Dashboard'));



registerReduxStore('dashboard', DashboardState, actions);


registerRoutes([
    {
        path:        '/dashboard',
        exact:       true,
        render:      <Dashboard />,
        title:       'Dashboard',
        private:     true,
        permissions: [],
    },
]);



registerNavigation({
    title:       'Dashboard',
    permissions: [],
    single:      false,
    top:         true,
    home:        true,
    icon:        <DollarOutlined />,
    children:    [
        {
            title:       'View Dashboard',
            url:         '/dashboard',
            icon:        <ProfileOutlined />,
            permissions: [],
        },
    ],
});


console.log('Registered Dashboard Plugin');